import { Menu } from "@headlessui/react";
import classNames from "classnames";
import { icon } from "@common/helpers/icons";
import { DropDownMenuProps } from "@common/types";
import { FadeTransition } from ".";

const positions = {
  "bottom-start": "bottom start",
  "bottom-end": "bottom end",
  "top-start": "top start",
  "top-end": "top end",
};

export function DropDownMenu({
  className,
  menu,
  button,
  label,
  size,
  position,
}: DropDownMenuProps) {
  return (
    <Menu as="div" className={classNames("relative inline-block", className)}>
      <Menu.Button as="div">
        {button || (
          <button
            aria-label={label}
            className="flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-ring/20"
          >
            {icon("dots-vertical", { className: "h-4 w-4" })}
          </button>
        )}
      </Menu.Button>

      <FadeTransition>
        <Menu.Items
          anchor={{
            to: positions[position || "bottom-start"] as any,
            gap: 8,
            padding: 16,
          }}
          portal
          className={classNames(
            "z-popover min-w-40 max-w-[calc(100vw-2rem)] rounded-lg border border-border bg-popover p-1 text-start text-sm leading-6 text-popover-foreground shadow-medium focus:outline-none",
            size === "small"
              ? "w-32"
              : size === "medium"
                ? "w-48"
                : size === "large"
                  ? "w-64"
                  : "",
          )}
        >
          <div>
            {menu.map((menu, index) => (
              <Menu.Item key={index}>
                {({ active }) => (
                  <a
                    onClick={menu.onClick}
                    href={menu.url}
                    className={classNames(
                      active ? "bg-muted" : "",
                      "flex cursor-pointer items-center rounded-md px-3 py-2.5 text-sm font-medium text-foreground space-s-2 [&_svg]:h-[18px] [&_svg]:w-[18px] [&_svg]:stroke-[2]",
                    )}
                  >
                    {menu.icon}
                    <div className="min-w-0 truncate">{menu.text}</div>
                  </a>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </FadeTransition>
    </Menu>
  );
}
